import { MenuItem } from '@chakra-ui/react'
import dayjs from 'dayjs'
import { FC } from 'react'
import { GrDocumentCsv } from 'react-icons/gr'

import useTools from '@hook/shared/use-tools'

import { exportToCSV } from '@helper/export/csvUtils'

export interface PurchaseCsvColumn {
  header: string
  field: string
}

interface PurchaseCsvExportItemProps {
  // Prefixo do arquivo: gera "<prefixo>-yyyy-MM-dd.csv"
  filenamePrefix: string
  columns: PurchaseCsvColumn[]
  // Montadas só no clique (evita processar a lista a cada render)
  getRows: () => Record<string, any>[]
  rowCount: number
  label?: string
}

// Item de menu genérico dos exports CSV da Config Compras.
// exportToCSV aplica a proteção contra fórmula e preserva zeros.
const PurchaseCsvExportItem: FC<PurchaseCsvExportItemProps> = ({
  filenamePrefix,
  columns,
  getRows,
  rowCount,
  label = 'Exportar Dados CSV'
}) => {
  const { isDisabled } = useTools()

  const handleExport = () => {
    exportToCSV({
      filename: `${filenamePrefix}-${dayjs().format('YYYY-MM-DD')}.csv`,
      headers: columns.map(column => column.header),
      fieldMapping: columns.map(column => column.field),
      data: getRows()
    })
  }

  return (
    <MenuItem
      p="2px 12px"
      fontSize="sm"
      _hover={{ bg: 'gray.400' }}
      isDisabled={isDisabled || rowCount === 0}
      onClick={handleExport}
      icon={<GrDocumentCsv />}
    >
      {label}
    </MenuItem>
  )
}

export default PurchaseCsvExportItem
